/**
 * Custom hook for fetching and managing content
 */

import { useState, useEffect } from 'react';
import contentManager from '../services/contentManager';

export const useContent = (autoFetch = true) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const result = await contentManager.fetchAllContent();
      setContent(result.classified);
      setErrors(result.errors);
    } catch (error) {
      console.error('Failed to fetch content:', error);
      setErrors([{ platform: 'all', error: error.message }]);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    await fetchContent();
  };

  useEffect(() => {
    if (autoFetch) {
      fetchContent();
    }
  }, [autoFetch]);

  return {
    content,
    loading,
    errors,
    refresh,
    getHeroContent: () => contentManager.getHeroContent(),
    getSectionContent: (section) => content?.[section] || [],
  };
};

export default useContent;
